<template>
    <b-modal
            id="add-job-code"
            ref="add-job-code"
            size="sm-size"
            centered
            hide-footer
            hide-header
            @hide="close"
    >
        <div class="modal-head">
            <h2 class="modal-title">
                {{label.get('add_new_job_codes')}}
            </h2>
        </div>
        <div class="content-wrapper hasScroll">
            <perfect-scrollbar>
                <div class="form-container">
                    <h5 class="section-title">
                        {{label.get('job_codes')}}
                    </h5>
                    <div
                            v-for="(item, idx) in jobCodes"
                            :key="idx"
                            class="input-wrapper"
                    >
                        <input
                                v-model="item.name"
                                ref="job"
                                type="text"
                                :placeholder="label.get('add_job_code_name_placeholder')"
                                class="atto-input"
                        >
                    </div>
                    <button
                            class="add-new-btn"
                            @click="addMoreJobCodes"
                    >
                      <i class="atto atto-add-more" />
                        {{label.get('add_new_job_code')}}
                    </button>
                </div>
            </perfect-scrollbar>
        </div>
        <div class="modal-footer">
            <div class="form-buttons">
                <button
                        class="atto-btn cancel"
                        @click="close"
                >
                    {{label.get('cancel')}}
                </button>
                <button
                        class="atto-btn submit add-jobs-btn"
                        :disabled="disabledSaveButton"
                        @click="addJobCodes"
                >
                    {{label.get('add_job_codes')}}
                </button>
            </div>
        </div>
    </b-modal>
</template>

<script>

    import JobCodesService from '../services/JobCodesService';

    export default {
        name: "AddJobCodeComponent",
        data() {
            return {
                disabledSaveButton: false,
                jobCodes: [
                    {
                        id: null,
                        name: ''
                    }
                ]
            }
        },
        mounted() {
            document.body.appendChild(this.$el);
            this.$refs['add-job-code'].show();
        },
        methods: {
            close() {
                this.$root.$emit('hideAddJobCode');
            },
            addMoreJobCodes() {
                let emptyFields = false;
                this.jobCodes.forEach((item) => {
                    if (item.name.trim() === '') {
                        emptyFields = true;
                    }
                });

                if (!emptyFields) {
                    this.jobCodes.push({
                        id: null,
                        name: ''
                    });
                }

                const _this = this;
                setTimeout(function () {
                    _this.$nextTick(() => {
                        const last = _this.$refs.job.pop();
                        last.focus();
                    });
                }, 100);

            },
            addJobCodes() {
                const data = this.jobCodes.filter((item) => {
                    return item.name.trim() !== '';
                });
                if (data.length === 0) {
                    return;
                }
                this.disabledSaveButton = true;
                JobCodesService.saveJobCodes({jobs: data}).then((result) => {
                    this.$root.$emit('hideAddJobCode', result.data);
                }).catch((error) => {
                    this.disabledSaveButton = false;
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>